import React from 'react';
import { GeometryCanvas } from '@interactive-room';

export function PrintGeometryCanvasBlock({ payload }: { payload: Record<string, unknown> }) {
  const studentDraw = payload.studentDraw === true;
  const geometry = payload.geometry as import('@interactive-room').GeometryPayload | undefined;

  const bodyText = String(payload.bodyText || '').trim();
  const prompt = String(payload.prompt || '').trim();
  const formulaHint = String(payload.formulaHint || '').trim();

  if (studentDraw || !geometry?.shapeType) {
    return (
      <div className="print-block__body print-geometry-canvas print-geometry-canvas--draw">
        {bodyText && <p className="print-instruction">{bodyText}</p>}
        {prompt && <p className="print-geometry-canvas__prompt">{prompt}</p>}
        <div className="print-geometry-canvas__draw-area" aria-label="Espacio para dibujar" />
        {formulaHint && <p className="print-geometry-canvas__formula">{formulaHint}</p>}
      </div>
    );
  }

  return (
    <div className="print-block__body print-geometry-canvas">
      {bodyText && <p className="print-instruction">{bodyText}</p>}
      {prompt && <p className="print-geometry-canvas__prompt">{prompt}</p>}
      <GeometryCanvas
        geometry={geometry}
        width={340}
        height={240}
        printMode
        caption={String(payload.title || '')}
      />
      {formulaHint && <p className="print-geometry-canvas__formula">{formulaHint}</p>}
    </div>
  );
}
